import React from 'react';

import IconSpill from 'components/icons/spill';

const NotFoundImage = () => <IconSpill width="220" height="240" />;

export default NotFoundImage;
